import { Star, Quote } from "lucide-react";

const TestimonialsSection = ({ testimonials }) => {
  return (
    <section id="testimonianze" className="py-24 bg-[#29383d]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#5abb3d] font-semibold tracking-[0.2em] uppercase text-sm">
            Testimonianze
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-white mt-4 tracking-tight">
            Cosa Dicono i Nostri Clienti
          </h2>
          <p className="text-white/70 mt-4 max-w-2xl mx-auto leading-relaxed">
            La soddisfazione dei nostri clienti è la nostra migliore pubblicità
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`testimonial-card bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 opacity-0 animate-fade-in-up stagger-${index + 1}`}
              data-testid={`testimonial-card-${testimonial.id}`}
            >
              {/* Quote Icon */}
              <Quote className="w-8 h-8 text-[#5abb3d] mb-4" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className={`w-4 h-4 ${
                      i < testimonial.rating ? "text-[#5abb3d] fill-[#5abb3d]" : "text-white/30"
                    }`}
                  />
                ))}
              </div>

              {/* Text */}
              <p className="text-white/80 leading-relaxed mb-6 text-sm">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="border-t border-white/10 pt-4">
                <p className="font-outfit font-semibold text-white">
                  {testimonial.name}
                </p>
                <p className="text-[#5abb3d] text-sm">
                  {testimonial.location}
                </p>
                <span className="inline-block mt-2 px-2 py-1 bg-[#5abb3d]/20 text-[#5abb3d] text-xs rounded-full">
                  {testimonial.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
